import * as React from 'react';
import px from 'prop-types';
import ProductPrice from '../../ProductPrice';
import ProductBadge from '../../ProductBadge';
import ProductInput from '../../ProductInput';

function getColumns(index, total) {
        if (total === 1) return 'col-12';

        if (total % 2 !== 0 && index === total - 1) return 'col-12';

        return 'col-6';
    }

export default function BuyBulkProductCard({ 
    facets,
    getFacetValueForProduct,
    getImageUrl,
    getProductInputProps,
    item,
    priceLabel,
    quantityLabel,
    rows,
    setAddToCartTip,
    skuLabel,
 }) {

    return (
        <div className="BuyBulkProductCard card mobile-product-card" style={{ height: '500px', margin: '0 8px', display: 'flex', flexDirection: 'column' }}>
            <div className="card-body">
                <div className="d-flex flex-column align-items-center mb-3">
                    <img
                        className="thumbnail"
                        src={getImageUrl(item.imageUrl, 120, 180)}
                        aria-hidden
                        alt="variant image"
                    />
                </div>

                <div className='d-flex flex-column justify-content-between' style={{height: '75%'}}>
                    <div className="d-flex justify-conent-center" style={{paddingLeft: '2rem'}}>
                        <div className="col-6">
                            <strong>{skuLabel}:</strong><br />
                            <p>{item.id}</p>
                        </div>
                        <div className="col-6">
                            <strong>{priceLabel}:</strong><br />
                            <ProductPrice priceInfo={item.priceInfo} quantity={rows[item.id]?.quantity} />
                        </div>
                    </div>
                    
                    {facets.length > 0 && (
                        <div className="facets-section mb-3" style={{paddingLeft: '2rem'}}>
                            <div className="d-flex w-100 flex-wrap">
                                {facets.map((facet, index) => {
                                    const facetValue = getFacetValueForProduct(item, facet.Attribute);
    
                                    if (facetValue && facetValue !== '-') {
                                        return (
                                            <div key={facet.Attribute} className={`${getColumns(index, facets.length)} mb-2`}>
                                                <strong>{facet.AttributeDisplayName || facet.Attribute}:</strong><br />
                                                {facetValue}
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                    )}
                    <div className="d-flex flex-column align-items-center justify-content-center mb-4">
                        <strong>{quantityLabel}:</strong>
                        {item.productInfo.StockStatus == "InStock" ? <ProductInput {...getProductInputProps(item)} onChange={() => setAddToCartTip(null)} /> : <ProductBadge badges={["Out Of Stock"]}/>}
                    </div>
                </div>                
            </div>
        </div>
    );
}
    
BuyBulkProductCard.propTypes = {
   facets: px.arrayOf(
        px.shape({
            Attribute: px.string,
            AttributeDefinition: px.string,
            AttributeDisplayName: px.string,
            AttributeFacetLabel: px.string,
            DependentAttribute: px.string,
            FacetColors: px.array,
            FacetRanges: px.array,
            FacetValues: px.array,
            SelectorControlType: px.string
        })
    ),
    getFacetValueForProduct: px.func,
    getImageUrl: px.func,
    getProductInputProps: px.func,
    item: px.object,
    priceLabel: px.string,
    quantityLabel: px.string,
    rows: px.object,
    setAddToCartTip: px.func,
    skuLabel: px.string,
    
}